// Maps a BE sourcing-run status to its FE pill i18n key (BRAND-9306 run-aware
// review views). Per repo i18n convention (CLAUDE.md §6 / AGENTS.md §6), new
// user-facing text must reference a translation key in
// src/apps/tribe/locales/en.json rather than a hardcoded string.
//
// D1 rec: an unrecognised status must render verbatim rather than throw, so
// a new BE status can ship ahead of a FE release without breaking the run
// bar. To preserve that, this returns `null` for unmapped statuses instead of
// a key — callers (RunScopeBar) fall back to rendering the raw status string
// when the result is null, rather than passing an unknown id to
// <FormattedMessage/>.
const STATUS_LABEL_KEYS: Record<string, string> = {
  importing: 'creatorSearch.vibeCheck.runScope.status.importing',
  ready_for_vibe_check: 'creatorSearch.vibeCheck.runScope.status.readyForVibeCheck',
  vibe_check_completed: 'creatorSearch.vibeCheck.runScope.status.vibeCheckCompleted',
  failed: 'creatorSearch.vibeCheck.runScope.status.failed',
  expired: 'creatorSearch.vibeCheck.runScope.status.expired',
}

export const sourcingRunStatusLabel = (status: string): string | null =>
  STATUS_LABEL_KEYS[status] ?? null
